export const updateSidebarMode = (mode) => async(dispatch) => {

    dispatch({
        type : 'UPDATE_SIDEBAR_MODE',
        payload : {
            mode: mode,
        },
    })
}
